var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3322",
    "data-name": "Group 3322",
    transform: "translate(22096 -11475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    transform: "translate(-22096 11475)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 69,
    r: 69,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 69,
    r: 68.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(-22051 11510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M123.517,11.654A23.1,23.1,0,0,0,103.891,0c-.348-.007-.7-.007-1.047,0a23.1,23.1,0,0,0-19.626,11.65,23.694,23.694,0,0,0-.309,23.412L99.786,65.957l.023.041a4.1,4.1,0,0,0,7.117,0l.023-.041,16.877-30.891a23.7,23.7,0,0,0-.309-23.412ZM103.368,30.839a9.571,9.571,0,1,1,9.571-9.571A9.582,9.582,0,0,1,103.368,30.839Z",
    transform: "translate(-79.968 0)",
    fill: "#ed193a"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/Location Icon.e1c5a05c5638eb1845b42a686d287238.svg";
export { ForwardRef as ReactComponent };